import React, { useState, useEffect } from "react";
import Footer from "../../../Components/Footer/Footer";
import CustomerSideBar from "../../../Components/sidebar/CustomerSideBar";
import CustHeader from '../../../Components/header/Header/CustHeader'

import { Box, Stack, Paper, Divider, Typography, Button } from "@mui/material";
import { useSelector } from 'react-redux'
import { SessionVerification } from "../../../Components/SessionManagement/SessionManagement";
import CustPaymentTable from "../../Component/CustPayment/CustPaymentTable";
import configServ from "../../../services/config";
import { useNavigate } from "react-router-dom";

const CustPayment = () => {
    //#region code
    const { user_id } = useSelector((state) => state.GlobalVariables);
    const open = useSelector((state) => state.sideExpand.open)
    const [tableData, setTableData] = useState([])
    const [miniLoader, setMiniLoader] = useState(false)
    const navigate = useNavigate()

    const fetchTableData = async () => {
        setMiniLoader(true)
        try {
            const result = await configServ.payment_list({ "user_id": user_id })
            // console.log(result)
            setTableData(result)
            setMiniLoader(false)
        } catch (err) {
            console.log(err)
            setMiniLoader(false)
        }
    }
    useEffect(() => {
        fetchTableData()
    }, []);

    const goToPay = () => {
        navigate('pay')
    };
    //#endregion

    return (
        <>
            <SessionVerification />
            <CustHeader />
            <CustomerSideBar />
            <Box sx={{
                marginLeft: {
                    xs: 7,
                    sm: 8,
                },
                ...(open && { marginLeft: 33 }),
                transition: '200ms',
                minHeight: '77vh',
                backgroundColor: '#EEEEEE77'
            }}>

                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                >
                    <Paper
                        sx={{
                            width: '90%',
                            margin: 5,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: 3,
                            pb: 5
                        }}
                    >
                        {/* <motion.h4 style={{ textAlign: 'center' }}
                            initial={{opacity:0, y:-20}}
                            animate={{opacity:1, y:0}}
                            transition={{duration:0.1}}
                        >
                            Payment List
                        </motion.h4> */}
                        <Stack
                            width='100%'
                            direction='row'
                            justifyContent='flex-start'
                        >
                            <Button
                                variant="contained"
                                onClick={goToPay}
                            >
                                Pay
                            </Button>
                        </Stack>
                        <Stack direction='column' justifyContent='flex-start' width='100%' my={2}>
                            <Divider />
                        </Stack>
                        {tableData !== undefined && (<CustPaymentTable tableData={tableData} miniLoader={miniLoader} />)}

                    </Paper>
                </Stack>
            </Box>
            <Footer />
        </>
    )
}
export default CustPayment